import { useEffect, useState } from "react";
import Axios from 'axios';

const EditProfilePic=({profilePicStateFunc, viewMode, webToken, userEmail, additionalStyles})=>{
    const [imgBlob, setImgBlob] = useState(null);
    const [imgString, setImgString]=useState(null);
    const [errorMsg,setErrorMsg]=useState("");
    const [isFileReady,setIsFileReady]=useState(false);

    const updloadProfilePic=()=>{
        Axios.post(`${alimAPIBaseURI}rpc/update_user_profile_pic`, {pro_pic:imgString},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
            if(data.data==="Profile pic updated")
            {
                setIsFileReady(false);
                localStorage.removeItem("alimProfilePic");
                document.dispatchEvent(profilePicEvent);
                showAlert(`Profile picture updated!`);
            }
        }).catch((error)=>{
            console.log(error);
            setSubmitDisabled(false);
        });
    }

    const updateProfilePic=()=>{
        if(profilePicStateFunc)
        {
            profilePicStateFunc(imgString);
        }
        else if(webToken&&userEmail)
        {
            updloadProfilePic();
        }
    }

    useEffect(()=>{
        if(isFileReady)
        {
            if(imgBlob!==null)
            {
                let reader = new FileReader();
                reader.readAsDataURL(imgBlob);
                reader.onloadend = function () {
                    let base64String = reader.result;
                    setImgString(base64String);
                } 
            }

            if(imgString!==null)
            {
                updateProfilePic();
            }
        }
    },[imgBlob,imgString])

    if(viewMode==="in-menu")
    {
        return(
            <div className="">
                <input
                    id="profile-pic-input"
                    className="opacity-0 absolute top-0 left-0"
                    type="file" 
                    accept="image/*" 
                    onChange={(input) => {
                        const file = input.target.files[0];
                        const supportedExt=["png","jpeg","jpg"];
                        if(file!==undefined)
                        {
                            setIsFileReady(true);
                            const fileExt= file.name.match(/\.([^\.]+)$/)[1];
                            if(file.size>51200)
                            {
                                showAlert("Please select a file with size 50KB or less.");
                                setImgBlob(null);
                                setImgString(null);
                                profilePicStateFunc(null);
                            }
                            else if(!supportedExt.includes(fileExt))
                            {
                                showAlert("Please select a file with extensions: png, jpg or jpeg.");
                                setImgBlob(null);
                                setImgString(null);
                                profilePicStateFunc(null);
                            }
                            else if(file.size<=51200)
                            {
                                //setErrorMsg("");
                                const fr = new FileReader();
                                fr.readAsArrayBuffer(file);
                                fr.onload = function () {
                                    const blob = new Blob([fr.result]);
                                    setImgBlob(blob);
                                };
                            }
                        }
                    }}
                />
                {
                    errorMsg!==""&&
                    <p className="text-deep-red font-medium">{errorMsg}</p>
                }

            </div>
        )
    }
    else
    {
        return(
            <div className="">
                <input
                    className={`rounded-md border border-light-blue/50 dark:border-light-blue ${additionalStyles?additionalStyles:""}`}
                    type="file" 
                    accept="image/*" 
                    onChange={(input) => {
                        const file = input.target.files[0];
                        const supportedExt=["png","jpeg","jpg"];
                        if(file!==undefined)
                        {
                            setIsFileReady(true);
                            const fileExt= file.name.match(/\.([^\.]+)$/)[1];
                            if(file.size>51200)
                            {
                                showAlert("Please select a file with size 50KB or less.");
                                setImgBlob(null);
                                setImgString(null);
                                profilePicStateFunc(null);
                            }
                            else if(!supportedExt.includes(fileExt))
                            {
                                showAlert("Please select a file with extensions: png, jpg or jpeg.");
                                setImgBlob(null);
                                setImgString(null);
                                profilePicStateFunc(null);
                            }
                            else if(file.size<=51200)
                            {
                                //setErrorMsg("");
                                const fr = new FileReader();
                                fr.readAsArrayBuffer(file);
                                fr.onload = function () {
                                    const blob = new Blob([fr.result]);
                                    setImgBlob(blob);
                                };
                            }
                        }
                    }}
                />
                {
                    errorMsg!==""&&
                    <p className="text-deep-red font-medium">{errorMsg}</p>
                }

            </div>
        )
    }
}

export default EditProfilePic;